import { InvitationForm2, SvgImg } from ".";
import { patterns, svgs } from "../consts";

const Invitation2 = ({ rsvp }) => {
  const backgroundStyle = {
    backgroundColor: `${rsvp?.bgColor}`,
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='${
      patterns[rsvp?.pattern]?.width
    }' height='${patterns[rsvp?.pattern]?.height}' viewBox='0 0 ${
      patterns[rsvp?.pattern]?.width
    } ${patterns[rsvp?.pattern]?.height}'%3E%3Cpath fill='%23${
      rsvp?.fgColor
    }' fill-opacity='${rsvp?.opacity}'  d='${
      patterns[rsvp?.pattern]?.path
    }'%3E%3C/path%3E%3C/svg%3E")`,
    backgroundRepeat: "repeat",
    backgroundSize: `${patterns[rsvp?.pattern]?.width * rsvp.patternScale}px ${
      patterns[rsvp?.pattern]?.height * rsvp.patternScale
    }px`,
  };

  const textStyle = {
    color: rsvp?.textColor,
  };
  const highlightStyle = {
    color: rsvp?.highlightColor,
  };
  const borderStyle = {
    border: "5px solid",
    borderColor: rsvp?.borderColor,
    boxShadow: `inset 0 2px 4px 0 ${rsvp?.borderColor}`,
  };

  return (
    <div
      className="relative text-center w-full min-h-screen p-6"
      style={backgroundStyle}
    >
      <div
        className="font-display top-20 p-4 w-full"
        style={rsvp?.border ? borderStyle : {}}
      >
        <h1
          className={`text-5xl md:text-7xl lg:text-9xl font-${rsvp.titleFont} mt-10 md:mt-20`}
          style={{ color: rsvp.titleColor }}
        >
          {rsvp?.eventName}
        </h1>
        {rsvp?.eventName && (
          <div className="flex flex-col gap-2">
            <p
              className={`text-lg md:text-xl lg:text-3xl mt-5 font-${rsvp.dateFont}`}
              style={{ color: rsvp.dateColor }}
            >
              {new Date(rsvp?.date).toLocaleDateString("hr-HR")}
            </p>
            <p
              className={`text-lg md:text-xl lg:text-3xl font-${rsvp.locationFont}`}
              style={{ color: rsvp.locationColor }}
            >
              {rsvp?.location}
            </p>
          </div>
        )}
        {rsvp?.timelineWithQuote &&
          rsvp?.events?.map((ev, idx) => (
            <div className="flex justify-center" key={idx}>
              <div className="flex flex-row items-center justify-center mt-10 gap-2.5 md:gap-5 w-4/5 sm:w-2/3 md:w-1/3 overflow-visible">
                {ev.icon && (
                  <SvgImg
                    src={svgs[rsvp.events[idx].icon]}
                    selected={false}
                    displayBorder={true}
                    highlightColor={rsvp.highlightColor}
                    textColor={rsvp.textColor}
                    scale={true}
                    // alt={`SVG ${key}`}
                    className="w-1/3"
                  />
                )}
                <div className="flex flex-col w-1/2">
                  <div className="flex flex-start flex-col">
                    <h1
                      className={`text-md md:text-lg lg:text-2xl text-start w-full font-${rsvp.textFont}`}
                      style={textStyle}
                    >
                      {ev.time}
                    </h1>
                    <h1
                      className={`text-lg md:text-xl lg:text-3xl text-start w-full font-${rsvp.textFont}`}
                      style={textStyle}
                    >
                      {ev.eventName}
                    </h1>
                    <h1
                      className={`text-md md:text-lg lg:text-2xl text-start w-full inline font-${rsvp.textFont}`}
                      style={textStyle}
                    >
                      {ev.location}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          ))}
        {rsvp.quote && (
          <>
            <h1
              className={`text-4xl md:text-5xl lg:text-7xl mt-10 font-${rsvp.quoteFont}`}
              style={{ color: rsvp.quoteColor }}
            >
              {rsvp.quoteText}
            </h1>
            <h1
              className={`text-4xl md:text-5xl lg:text-7xl font-monsieur mt-10 font-${rsvp.highlightFont}`}
              style={highlightStyle}
            >
              {rsvp.quoteText}
            </h1>
          </>
        )}
        {rsvp?.includeForm && <InvitationForm2 rsvp={rsvp} />}
      </div>
    </div>
  );
};

export default Invitation2;
